import IconPdf from "../../Icon/IconPdf";

function FamilyTreePdfCard({ title, pdf }) {
  const baseName = pdf?.toLowerCase().endsWith(".pdf") ? pdf.slice(0, -4) : pdf;
  const displayTitle = title || baseName;
  const formattedTitle = displayTitle
    ? displayTitle.charAt(0).toUpperCase() + displayTitle.slice(1)
    : "PDF";

  return (
    <a
      href={`https://storage.strinix.com/cpm/vanshavali-xx/${pdf}`}
      rel="noreferrer"
      target="_blank"
    >
      <div className="rounded-2 p-4  border text-center mb-4">
        <IconPdf width="100" height="100" />
        <h4 className="mt-2 mb-1">{formattedTitle}</h4>
      </div>
    </a>
  );
}

export default FamilyTreePdfCard;
